import ad from './icons/ad.svg';
import data from './icons/data.svg';
import infrastructure from './icons/infrastructure.svg';
import priceChart from './icons/priceChart.svg';

export interface IData {
  title: string;
  afterTitle?: string;
  subTitle: string;
  list: string[];
  iconSrc: string;
}

export const DATA: IData[] = [
  {
    title: 'Объявления с Циан',
    subTitle: 'Вся Россия',
    list: ['Опубликованные объявления', 'Снятые с экспозиции объявления'],
    iconSrc: ad,
  },
  {
    title: 'Данные по продажам',
    afterTitle: '*',
    subTitle: 'Москва и область, СПБ и область',
    list: ['ДДУ', 'Эскроу'],
    iconSrc: data,
  },
  {
    title: 'Инфраструктура и застройка',
    subTitle: 'Вся Россия',
    list: ['Транспортная доступность', 'Близость к школам, магазинам'],
    iconSrc: infrastructure,
  },
  {
    title: 'Динамика цен',
    subTitle: 'Вся Россия',
    list: ['Первичка и вторичка', 'Коммерческая недвижимость'],
    iconSrc: priceChart,
  },
];
